import { useEffect, useState } from 'react';
import { detectInAppBrowser } from '../utils/inAppBrowser';
import { reportBootEvent } from '../utils/bootDiagnostics';

const DISMISS_KEY = 'inapp_browser_hint_dismissed';

const barStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  zIndex: 100001,
  background: '#1e293b',
  color: '#fff',
  padding: '10px 14px',
  fontSize: 13,
  lineHeight: 1.45,
  fontFamily: 'system-ui, -apple-system, sans-serif',
  boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
};

const btnStyle = {
  marginTop: 8,
  padding: '8px 14px',
  border: 'none',
  borderRadius: 10,
  background: '#3b82f6',
  color: '#fff',
  fontSize: 13,
  fontWeight: 600,
  cursor: 'pointer',
};

const closeStyle = {
  float: 'right',
  marginLeft: 8,
  background: 'transparent',
  border: 'none',
  color: '#94a3b8',
  fontSize: 18,
  lineHeight: 1,
  cursor: 'pointer',
  padding: 0,
};

function hintMessage(info) {
  if (info.telegram) {
    return 'Страница открыта во встроенном браузере Telegram. Если видите пустой экран — откройте в Safari или Chrome: ⋯ → «Открыть в браузере».';
  }
  return 'Страница открыта во встроенном браузере. Если приложение не загружается — откройте ссылку в обычном браузере (Safari / Chrome).';
}

export default function InAppBrowserHint() {
  const [visible, setVisible] = useState(false);
  const [info, setInfo] = useState(null);

  useEffect(() => {
    const detected = detectInAppBrowser();
    if (!detected.any) return;

    reportBootEvent('boot_start', {
      source: 'in_app_browser',
      ...detected,
    });

    try {
      if (localStorage.getItem(DISMISS_KEY) === '1') return;
    } catch { /* ignore */ }

    setInfo(detected);
    setVisible(true);
  }, []);

  if (!visible || !info) return null;

  return (
    <div style={barStyle} role="status">
      <button
        type="button"
        style={closeStyle}
        aria-label="Закрыть"
        onClick={() => {
          try { localStorage.setItem(DISMISS_KEY, '1'); } catch { /* ignore */ }
          setVisible(false);
        }}
      >
        ×
      </button>
      <div>{hintMessage(info)}</div>
      <button
        type="button"
        style={btnStyle}
        onClick={() => window.location.reload()}
      >
        Перезагрузить
      </button>
    </div>
  );
}
